<div class="card__section" *ngIf="removed.length > 0">
  <div class="row">
    <div class="columns">
      <h3 class="typography--subheader">Removed Rate Packages</h3>
      <p class="typography--caption">
        <span class="label label--alert">{{ removed.length }} rate package(s) will be removed because they are not present in the uploaded file.</span>
      </p>
    </div>
  </div>
  <div class="table" role="table">
    <span role="rowgroup">
      <span class="table__row table__row--header" role="row">
        <span class="table__cell table__cell--half" role="columnheader">#</span>
        <span class="table__cell table__cell--one table__cell--align-left" role="columnheader">Key</span>
        <span class="table__cell table__cell--tripple table__cell--align-left" role="columnheader">Description</span>
      </span>
    </span>
    <div role="rowgroup">
      <span
        class="table__row"
        role="row"
        *ngFor="let item of pagedItems; let i = index"
      >
        <span class="table__cell table__cell--half" role="cell">{{ (currentPage - 1) * pageSize + i + 1 }}</span>
        <span class="table__cell table__cell--one table__cell--align-left" role="cell">{{ item.key }}</span>
        <span class="table__cell table__cell--tripple table__cell--align-left" role="cell">{{ item.description }}</span>
      </span>
    </div>
  </div>
  <generic-pagination
    [currentPage]="currentPage"
    [pageSize]="pageSize"
    [totalItems]="removed.length"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  ></generic-pagination>
</div>